export default __webpack_public_path__ + "static/media/briefcase-with-text.9e0f93dc.svg";